import React from 'react'

const DialogMain = ({ children, className }) => {
	return <div className={`tt-pb-16  tt-overflow-auto tt-px-32 tt-flex-1, ${className}`}>{children}</div>
}

export default DialogMain
